import { modelsConstants } from '../../constants/redux/models.contants'

const initialState = {
  data: null,
  isLoading: false,
  isError: false,
}

const models = (state = initialState, action) => {
  switch (action.type) {
    case modelsConstants.INIT:
      return {
        ...state,
        isLoading: true,
        isError: false,
      }
    case modelsConstants.SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        isLoading: false,
      }
    case modelsConstants.FAILURE:
      return {
        isLoading: true,
        isError: true,
      }
    case modelsConstants.CLEAR:
      return initialState
    default:
      return state
  }
}

export { models }
